import React, { useState, useRef, useEffect, useCallback } from "react";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import 'ag-grid-enterprise';
import moment from "moment";


const Asset = () => {

    const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.assets}`;
    const perPage = 10;
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState();
    const [error, setError] = useState("")
    const gridRef = useRef();
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const navigate = useNavigate();
    const [deleteDisable, setDeleteDisable] = useState(true);

    const handleDateFormat = (props) => {
        return props.value && moment(props.value).format('DD-MM-YYYY')
    }

    const [columnDefs, setColumnDefs] = useState([
        { field: 'assetSrlNum', enableRowGroup: true, },
        { field: 'assetName', enableRowGroup: true, },
        { field: 'employeeName', enableRowGroup: true, },
        { field: 'handOverDate', enableRowGroup: true, cellRenderer: handleDateFormat },
        { field: 'expiryDate', enableRowGroup: true, cellRenderer: handleDateFormat },
        { field: 'expairyDays', enableRowGroup: true, },
        { field: 'assetStatus', enableRowGroup: true, },
        { field: 'approvalStatus', enableRowGroup: true, },
        { field: 'condition', enableRowGroup: true, },
        { field: 'purchasePrice', enableRowGroup: true, },
        { field: 'notified', enableRowGroup: true, cellRenderer :IconComponent },
        { field: 'notify', enableRowGroup: true, },
    ]);

    function IconComponent(props) {
        let bool = props?.data?.active
        return <TaskAltIcon />
    }

    const getAssets = async () => {
        const employeeUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;
        try {
            const res = await OAuthService.getList(url + '?sort=cityName,asc&size=1000');
            let assets = res?.data;
            assets =await Promise.all(assets ? assets.map(async(asset)=>{
                const employee = await OAuthService.getEditData(employeeUrl, asset.employeeId);
                const employeeFullName = `${employee.data.empFirstName} ${employee.data.empMiddleName} ${employee.data.empLastName}`
                asset.employeeName = employeeFullName;
                return asset;
            }) : "")
           setRowData(assets);
        } catch (error) {
            setError(error.message);
            console.log(error);
        }
    }

    const onGridReady = useCallback((params) => {
        getAssets();
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, []);

    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'Assets.xlsx',
            sheetName: 'Assets'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const handlePurge = (e) => {
        selectedRows.map(async (row) => {
            try {
                await OAuthService.deleteData(url, row.assetId);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                getAssets();
            } catch (error) {
                console.log("eror", error);
                setError(error.message);
            }
        })
    };

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

    const onRowDoubleClicked = (params) => {
        navigate('/editAsset/' + selectedRows[0]?.assetId)
    }

    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows]);


    return (
        <>
            <ListPageHeader
                componentName="Assets"
                onBtExport={onBtExport}
                handlePurge={handlePurge}
                addPageLink="/addAsset"
                pageName="Assets List"
                error={error}
                deleteDisable={deleteDisable}
                successMsg={successMsg}
                snackState={snackState}
                gridRef={gridRef}
            />
            <div className="h-full">
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onRowDoubleClicked={onRowDoubleClicked}
                    gridRef={gridRef}
                    paginationPageSize={perPage}
                    cacheBlockSize={perPage}
                    saveGridStateName={'Assets'}
                />
            </div>
        </>
    )
}

export default Asset